module.exports = __webpack_public_path__ + "static/media/rating_svg.1b9c7b0c.svg";